import { JSX } from 'react';

export type MessageType = 'error' | 'warning' | 'info' | 'success';
export const messagesIcons: Record<MessageType, JSX.Element> = {
  error: (
    <svg className='h-5 w-5 text-red-600' fill='currentColor' viewBox='0 0 20 20'>
      <path d='M8.257 3.099c.765-1.36 2.68-1.36 3.445 0l6.516 11.6c.75 1.336-.213 3.001-1.722 3.001H3.464c-1.51 0-2.472-1.665-1.722-3.001l6.515-11.6zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-.25-6.75a.75.75 0 00-1.5 0v4a.75.75 0 001.5 0v-4z' />
    </svg>
  ),
  warning: (
    <svg className='h-5 w-5 text-yellow-600' fill='currentColor' viewBox='0 0 20 20'>
      <path d='M8.257 3.099c.765-1.36 2.68-1.36 3.445 0l6.516 11.6c.75 1.336-.213 3.001-1.722 3.001H3.464c-1.51 0-2.472-1.665-1.722-3.001l6.515-11.6zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-.25-6.75a.75.75 0 00-1.5 0v4a.75.75 0 001.5 0v-4z' />
    </svg>
  ),
  info: (
    <svg className='h-5 w-5 text-blue-600' fill='currentColor' viewBox='0 0 20 20'>
      <path d='M18 10A8 8 0 11 2 10a8 8 0 0116 0zm-8-4a1 1 0 100-2 1 1 0 000 2zm1 2a1 1 0 00-2 0v5a1 1 0 002 0V8z' />
    </svg>
  ),
  success: (
    <svg className='h-5 w-5 text-green-600' fill='currentColor' viewBox='0 0 20 20'>
      <path
        fillRule='evenodd'
        d='M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.707a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z'
        clipRule='evenodd'
      />
    </svg>
  ),
};
